<template>
  <div class="page">
    <div class="filter-bar">
      <span @click="selectYear">
        年份 {{ year }}
        <i class="caret"></i>
      </span>
      <span>
        {{ querytype }}
        <i class="caret"></i>
        <select
          class="filter-item__select"
          v-model="querytype"
          @change="searchCashflowMonth"
        >
          <option :value="'部门'">部门</option>
          <option :value="'人员'">人员</option>
          <option :value="'费用类别+类型'">费用类别+类型</option>
          <option :value="'部门+费用'">部门+费用</option>
          <option :value="'人员+费用'">人员+费用</option>
        </select>
      </span>
    </div>

    <div class="canvas-title">{{ title }}</div>
    <div class="canvas-box">
      <canvas id="myChart" class="myChart" v-show="result.details"></canvas>
      <div class="list-empty" v-show="!result.details">暂无数据</div>
    </div>

    <div class="list-box" v-if="result.details">
      <div class="list-left">
        <div class="list-cell">
          <div class="list-cell__main height-36">
            <div class="list-cell__index"></div>
            <div class="list-cell__toggle text-header">年度预算总额</div>
            <div class="list-cell__toggle text-header">年度实际费用</div>
          </div>
        </div>
        <div class="list-cell" v-for="(item, index) in list" :key="index">
          <div
            class="list-cell__main"
            :class="selected == index + 1 ? 'bg-color' : ''"
            @click="open(item, index + 1)"
          >
            <div class="list-cell__index">
              <span>{{ index + 1 }}</span>
            </div>
            <div class="list-cell__content" v-format="'#,##0.00'">
              {{ item.plantotal }}
            </div>
            <div class="list-cell__content" v-format="'#,##0.00'">
              {{ item.feetotal }}
            </div>
          </div>
        </div>
      </div>
      <div class="list-right">
        <div class="list-cell" :class="getClassName()">
          <div class="list-cell__main">
            <div
              class="list-cell__100 text-header"
              v-if="querytype == '部门' || querytype == '部门+费用'"
            >
              部门
            </div>
            <div
              class="list-cell__100 text-header"
              v-if="querytype == '人员' || querytype == '人员+费用'"
            >
              人员
            </div>
            <div
              class="list-cell__100 text-header"
              v-if="
                querytype == '费用类别+类型' ||
                querytype == '部门+费用' ||
                querytype == '人员+费用'
              "
            >
              费用类别
            </div>
            <div
              class="list-cell__100 text-header"
              v-if="
                querytype == '费用类别+类型' ||
                querytype == '部门+费用' ||
                querytype == '人员+费用'
              "
            >
              费用类型
            </div>
            <div
              class="list-cell__100 text-header"
              v-if="querytype == '部门+费用' || querytype == '人员+费用'"
            >
              是否结转
            </div>
            <div class="text-two-header">
              <div class="width-200">1月</div>
              <div class="width-200">
                <span class="small-header">预算额度</span>
                <span class="small-header">实际额度</span>
                <span class="small-header">实际费用</span>
              </div>
            </div>
            <div class="text-two-header">
              <div class="width-200">2月</div>
              <div class="width-200">
                <span class="small-header">预算额度</span>
                <span class="small-header">实际额度</span>
                <span class="small-header">实际费用</span>
              </div>
            </div>
            <div class="text-two-header">
              <div class="width-200">3月</div>
              <div class="width-200">
                <span class="small-header">预算额度</span>
                <span class="small-header">实际额度</span>
                <span class="small-header">实际费用</span>
              </div>
            </div>
            <div class="text-two-header">
              <div class="width-200">4月</div>
              <div class="width-200">
                <span class="small-header">预算额度</span>
                <span class="small-header">实际额度</span>
                <span class="small-header">实际费用</span>
              </div>
            </div>
            <div class="text-two-header">
              <div class="width-200">5月</div>
              <div class="width-200">
                <span class="small-header">预算额度</span>
                <span class="small-header">实际额度</span>
                <span class="small-header">实际费用</span>
              </div>
            </div>
            <div class="text-two-header">
              <div class="width-200">6月</div>
              <div class="width-200">
                <span class="small-header">预算额度</span>
                <span class="small-header">实际额度</span>
                <span class="small-header">实际费用</span>
              </div>
            </div>
            <div class="text-two-header">
              <div class="width-200">7月</div>
              <div class="width-200">
                <span class="small-header">预算额度</span>
                <span class="small-header">实际额度</span>
                <span class="small-header">实际费用</span>
              </div>
            </div>
            <div class="text-two-header">
              <div class="width-200">8月</div>
              <div class="width-200">
                <span class="small-header">预算额度</span>
                <span class="small-header">实际额度</span>
                <span class="small-header">实际费用</span>
              </div>
            </div>
            <div class="text-two-header">
              <div class="width-200">9月</div>
              <div class="width-200">
                <span class="small-header">预算额度</span>
                <span class="small-header">实际额度</span>
                <span class="small-header">实际费用</span>
              </div>
            </div>
            <div class="text-two-header">
              <div class="width-200">10月</div>
              <div class="width-200">
                <span class="small-header">预算额度</span>
                <span class="small-header">实际额度</span>
                <span class="small-header">实际费用</span>
              </div>
            </div>
            <div class="text-two-header">
              <div class="width-200">11月</div>
              <div class="width-200">
                <span class="small-header">预算额度</span>
                <span class="small-header">实际额度</span>
                <span class="small-header">实际费用</span>
              </div>
            </div>
            <div class="text-two-header">
              <div class="width-200">12月</div>
              <div class="width-200">
                <span class="small-header">预算额度</span>
                <span class="small-header">实际额度</span>
                <span class="small-header">实际费用</span>
              </div>
            </div>
          </div>
          <div
            class="list-cell"
            :class="getClassName()"
            v-for="(items, index2) in list"
            :key="index2"
          >
            <div
              class="list-cell__main"
              :class="selected == index2 + 1 ? 'bg-color' : ''"
              @click="open(items, index2 + 1)"
            >
              <div
                class="list-cell__150"
                v-if="querytype == '部门' || querytype == '部门+费用'"
              >
                {{ items.fl_dpname }}
              </div>
              <div
                class="list-cell__150"
                v-if="querytype == '人员' || querytype == '人员+费用'"
              >
                {{ items.fl_emname }}
              </div>
              <div
                class="list-cell__150"
                v-if="
                  querytype == '费用类别+类型' ||
                  querytype == '部门+费用' ||
                  querytype == '人员+费用'
                "
              >
                {{ items.fl_feetype }}
              </div>
              <div
                class="list-cell__150"
                v-if="
                  querytype == '费用类别+类型' ||
                  querytype == '部门+费用' ||
                  querytype == '人员+费用'
                "
              >
                {{ items.fl_itemname }}
              </div>
              <div
                class="list-cell__150"
                v-if="querytype == '部门+费用' || querytype == '人员+费用'"
              >
                {{ items.fl_allowend ? "是" : "否" }}
              </div>
              <div class="list-cell__toggle color-blue" v-format="'#,##0.00'">
                {{ items.planamount1 }}
              </div>
              <div class="list-cell__toggle color-green" v-format="'#,##0.00'">
                {{ items.actamount1 }}
              </div>
              <div class="list-cell__toggle color-red" v-format="'#,##0.00'">
                {{ items.feeamount1 }}
              </div>
              <div class="list-cell__toggle color-blue" v-format="'#,##0.00'">
                {{ items.planamount2 }}
              </div>
              <div class="list-cell__toggle color-green" v-format="'#,##0.00'">
                {{ items.actamount2 }}
              </div>
              <div class="list-cell__toggle color-red" v-format="'#,##0.00'">
                {{ items.feeamount2 }}
              </div>
              <div class="list-cell__toggle color-blue" v-format="'#,##0.00'">
                {{ items.planamount3 }}
              </div>
              <div class="list-cell__toggle color-green" v-format="'#,##0.00'">
                {{ items.actamount3 }}
              </div>
              <div class="list-cell__toggle color-red" v-format="'#,##0.00'">
                {{ items.feeamount3 }}
              </div>
              <div class="list-cell__toggle color-blue" v-format="'#,##0.00'">
                {{ items.planamount4 }}
              </div>
              <div class="list-cell__toggle color-green" v-format="'#,##0.00'">
                {{ items.actamount4 }}
              </div>
              <div class="list-cell__toggle color-red" v-format="'#,##0.00'">
                {{ items.feeamount4 }}
              </div>
              <div class="list-cell__toggle color-blue" v-format="'#,##0.00'">
                {{ items.planamount5 }}
              </div>
              <div class="list-cell__toggle color-green" v-format="'#,##0.00'">
                {{ items.actamount5 }}
              </div>
              <div class="list-cell__toggle color-red" v-format="'#,##0.00'">
                {{ items.feeamount5 }}
              </div>
              <div class="list-cell__toggle color-blue" v-format="'#,##0.00'">
                {{ items.planamount6 }}
              </div>
              <div class="list-cell__toggle color-green" v-format="'#,##0.00'">
                {{ items.actamount6 }}
              </div>
              <div class="list-cell__toggle color-red" v-format="'#,##0.00'">
                {{ items.feeamount6 }}
              </div>
              <div class="list-cell__toggle color-blue" v-format="'#,##0.00'">
                {{ items.planamount7 }}
              </div>
              <div class="list-cell__toggle color-green" v-format="'#,##0.00'">
                {{ items.actamount7 }}
              </div>
              <div class="list-cell__toggle color-red" v-format="'#,##0.00'">
                {{ items.feeamount7 }}
              </div>
              <div class="list-cell__toggle color-blue" v-format="'#,##0.00'">
                {{ items.planamount8 }}
              </div>
              <div class="list-cell__toggle color-green" v-format="'#,##0.00'">
                {{ items.actamount8 }}
              </div>
              <div class="list-cell__toggle color-red" v-format="'#,##0.00'">
                {{ items.feeamount8 }}
              </div>
              <div class="list-cell__toggle color-blue" v-format="'#,##0.00'">
                {{ items.planamount9 }}
              </div>
              <div class="list-cell__toggle color-green" v-format="'#,##0.00'">
                {{ items.actamount9 }}
              </div>
              <div class="list-cell__toggle color-red" v-format="'#,##0.00'">
                {{ items.feeamount9 }}
              </div>
              <div class="list-cell__toggle color-blue" v-format="'#,##0.00'">
                {{ items.planamount10 }}
              </div>
              <div class="list-cell__toggle color-green" v-format="'#,##0.00'">
                {{ items.actamount10 }}
              </div>
              <div class="list-cell__toggle color-red" v-format="'#,##0.00'">
                {{ items.feeamount10 }}
              </div>
              <div class="list-cell__toggle color-blue" v-format="'#,##0.00'">
                {{ items.planamount11 }}
              </div>
              <div class="list-cell__toggle color-green" v-format="'#,##0.00'">
                {{ items.actamount11 }}
              </div>
              <div class="list-cell__toggle color-red" v-format="'#,##0.00'">
                {{ items.feeamount11 }}
              </div>
              <div class="list-cell__toggle color-blue" v-format="'#,##0.00'">
                {{ items.planamount12 }}
              </div>
              <div class="list-cell__toggle color-green" v-format="'#,##0.00'">
                {{ items.actamount12 }}
              </div>
              <div class="list-cell__toggle color-red" v-format="'#,##0.00'">
                {{ items.feeamount12 }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import F2 from '@antv/f2'
import F2 from "@antv/f2/lib/index";
import ScrollBar from "@antv/f2/lib/plugin/scroll-bar";
import "@antv/f2/lib/interaction/pan";

export default {
  data() {
    let year = new Date().getFullYear();

    return {
      result: {},
      querytype: "部门",
      querytypeObj: {
        部门: "dept",
        人员: "empl",
        "费用类别+类型": "feetype",
        "部门+费用": "deptfeetype",
        "人员+费用": "emplfeetype",
      },
      list: [],
      year,
      chart: null,
      textArr: [],
      title: "", //标题
      selected: 1,
    };
  },
  mounted() {
    this.searchCashflowMonth();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
  selectYear() {
    var me = this,
      year = new Date().getFullYear(),
      years = [];
    for (let i = year - 20; i <= year + 20; i++) {
      years.push({
        value: i,
        label: i + "年",
      });
    }
    me.$weui.picker(years, {
      title: "选择年份",
      defaultValue: [year],
      onConfirm: function (r) {
        me.year = r[0].value;
        me.searchCashflowMonth();
      },
    });
  },
  getClassName() {
    let me = this,
      className = "width-customer";
    if (me.querytype == "部门" || me.querytype == "人员") {
      className = "width-customer";
    }
    if (me.querytype == "部门+费用" || me.querytype == "人员+费用") {
      className = "width-all";
    }
    if (me.querytype == "费用类别+类型") {
      className = "width-type";
    }
    return className;
  },
  searchCashflowMonth() {
    let me = this;

    me.$ajax({
      url: "/api/oa/feebudget/report/year",
      params: {
        year: me.year,
        querytype: me.querytypeObj[me.querytype] || "dept",
      },
    }).then(function (res) {
      if (res.success) {
        me.result = res.data;
        // 添加安全检查
        const processedData = me.deal(me.result.monthitems || []);
        me.initChart(processedData);
        me.list = me.result.details ? me.result.details : [];
      } else {
        // 如果API调用失败，也要确保图表被正确处理
        me.initChart([]);
      }
    }).catch(function(error) {
      console.error('API调用失败:', error);
      me.initChart([]);
    });
  },
  open(data, index) {
    let me = this;
    me.selected = index;
    // 添加安全检查
    const processedData = me.deal2(data || {});
    me.initChart(processedData);
  },
  deal(data) {
    if (!data || !Array.isArray(data)) {
      // 返回一个默认的12个月的数据结构
      let defaultTextArr = [];
      for (let i = 0; i < 12; i++) {
        defaultTextArr.push(`${i + 1}月`);
      }
      this.textArr = defaultTextArr;
      
      let arr = [
        { index: -1, type: "预算额度", value: 0 },
        { index: 12, type: "预算额度", value: 0 },
      ];
      for (let i = 0; i < 12; i++) {
        arr.push(
          {
            index: i,
            text: defaultTextArr[i],
            type: "预算额度",
            value: 0,
          },
          {
            index: i,
            text: defaultTextArr[i],
            type: "实际额度",
            value: 0,
          },
          {
            index: i,
            text: defaultTextArr[i],
            type: "实际费用",
            value: 0,
          }
        );
      }
      return arr;
    }
    
    let me = this;
    me.textArr = [];
    for (let i = 0; i < 12; i++) {
      me.textArr.push((data[i] && data[i].text) ? data[i].text : `${i + 1}月`);
    }
    
    let arr = [
      { index: -1, type: "预算额度", value: 0 },
      { index: 12, type: "预算额度", value: 0 },
    ];
    for (let i = 0; i < 12; i++) {
      arr.push(
        {
          index: i,
          text: me.textArr[i],
          type: "预算额度",
          value: (data[i] && data[i].planamount) ? data[i].planamount : 0,
        },
        {
          index: i,
          text: me.textArr[i],
          type: "实际额度",
          value: (data[i] && data[i].actamount) ? data[i].actamount : 0,
        },
        {
          index: i,
          text: me.textArr[i],
          type: "实际费用",
          value: (data[i] && data[i].feeamount) ? data[i].feeamount : 0,
        }
      );
    }
    return arr;
  },
  deal2(data) {
    if (!data) {
      // 返回默认数据结构
      const textArr = [
        "01月", "02月", "03月", "04月", "05月", "06月",
        "07月", "08月", "09月", "10月", "11月", "12月",
      ];
      
      let arr = [
        { index: -1, type: "实际额度", value: 0 },
        { index: 12, type: "实际额度", value: 0 },
      ];
      for (let i = 0; i < 12; i++) {

        arr.push(
          {
            index: i,
            text: textArr[i],
            type: "实际额度",
            value: 0,
          },
          {
            index: i,
            text: textArr[i],
            type: "实际费用",
            value: 0,
          },
          {
            index: i,
            text: textArr[i],
            type: "预算额度",
            value: 0,
          }
        );
      }
      return arr;
    }
    
    const textArr = [
      "01月", "02月", "03月", "04月", "05月", "06月",
      "07月", "08月", "09月", "10月", "11月", "12月",
    ];

    let arr = [
      { index: -1, type: "实际额度", value: 0 },
      { index: 12, type: "实际额度", value: 0 },
    ];
    for (let i = 0; i < 12; i++) {
      const month = i + 1;
      arr.push(
        {
          index: i,
          text: textArr[i],
          type: "实际额度",
          value: data["actamount" + month] || 0,
        },
        {
          index: i,
          text: textArr[i],
          type: "实际费用",
          value: data["feeamount" + month] || 0,
        },
        {
          index: i,
          text: textArr[i],
          type: "预算额度",
          value: data["planamount" + month] || 0,
        }
      );
    }
    return arr;
  },
  onResize() {
    var chart = this.chart;
    if (chart) {
      this.chart = chart.destroy();
      // 添加安全检查
      const processedData = this.deal(this.result.monthitems || []);
      this.initChart(processedData);
    }
  },
  initChart(data) {
    // 添加数据验证
    if (!data || !Array.isArray(data)) {
      console.warn("图表数据格式不正确，使用默认数据");
      data = []; // 使用空数组
    }

    var me = this,
      chart = me.chart;
    if (chart) {
      chart.changeData(data);
      return;
    }

    // 只有当数据存在时才创建图表
    if (data.length === 0) {
      // 如果没有数据，可以选择不创建图表或显示空白图表
      console.log("没有数据，不创建图表");
      return;
    }

    me.chart = chart = new F2.Chart({
      id: "myChart",
      width: window.innerWidth,
      height: Math.min(window.innerHeight * 0.6, 300),
      pixelRatio: window.devicePixelRatio,
      plugins: ScrollBar,
    });

    chart.source(data, {
      index: {
        type: "linear",
        tickInterval: 1,
        min: -1,
        max: window.innerWidth > window.innerHeight ? 12 : 6,
        formatter: function (i) {
          // 添加更严格的安全检查
          if (!me.textArr || !Array.isArray(me.textArr) || i < 0 || i >= me.textArr.length) {
            return String(i); // 返回索引作为默认值
          }
          return me.textArr[i] || String(i);
        },
      },
    });

    chart
      .interval()
      .position("index*value")
      .color("type", (val) => {
        if (val === "预算额度") {
          return "#2eadf5";
        } else if (val === "实际额度") {
          return "#16b603";
        } else if (val === "实际费用") {
          return "#e44959";
        }
        return "#ccc"; // 默认颜色
      })
      .adjust({
        type: "dodge",
        marginRatio: 0.01, // 设置分组间柱子的间距
      });

    if (window.innerWidth < window.innerHeight) {
      // 定义进度条
      chart.scrollBar({
        mode: "x",
        xStyle: {
          backgroundColor: "#e8e8e8",
          fillerColor: "#808080",
          offsetY: -2,
        },
      });
    }
    chart.legend({
      align: "center",
      itemWidth: null,
    });
    chart.interaction("pan");
    chart.render();
  },
},
};
</script>

<style scoped>
.list-empty {
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background: #fff;
  color: #8b8b8b;
  font-size: 12px;
}
.bg-color {
  background: #fabcc1;
}
.color-green {
  color: #2bb72e;
}
.color-red {
  color: #e44959;
}
.color-blue {
  color: #2eadf5;
}
.filter-bar {
  width: 100%;
  background: var(--weui-BG-2);
  box-sizing: border-box;
  text-align: center;
  font-size: 13px;
  padding: 11px 0 9px 0;
  color: #9b9b9b;
  margin-bottom: 1px;
  display: flex;
}
.filter-bar span {
  margin: 0 auto;
  flex: 1;
  position: relative;
}
.filter-item__select {
  position: absolute;
  margin: 0;
  padding: 0;
  border: 0;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.filter-item__select option {
  color: var(--weui-FG-0);
  background: var(--weui-BG-2);
}
.nav {
  padding: 10px 20px;
  display: flex;
  justify-content: space-around;
  background: var(--weui-BG);
}
.nav .selected {
  color: #38559f;
}
.canvas-title {
  padding-top: 10px;
  font-size: 12px;
  font-weight: bold;
  width: 100%;
  text-align: center;
  background: var(--weui-BG);
}
.canvas-box {
  /* width: 100%;
  height: 100%; */
  background: var(--weui-BG);
}

.list-box {
  margin-top: 5px;
  background: var(--weui-BG);
  display: flex;
}
.list-left {
  width: 180px;
  display: flex;
  flex-direction: column;
}
.list-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-x: scroll;
}
.report-item {
  width: calc(100% - 20px);
  height: 30px;
  margin: 0 auto;
  font-size: 13px;
  border-bottom: 1px solid #cccccc;
  line-height: 30px;
  color: var(--weui-FG-0);
  display: flex;
}
.font-bold {
  font-weight: bold;
}
.report-item .report-item-name {
  flex: 2;
  text-align: left;
  padding: 0 2px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.report-item .report-item-year {
  flex: 1;
  text-align: center;
  padding: 0 2px;
}
.report-item .report-item-month {
  flex: 1;
  text-align: center;
  padding: 0 2px;
}

.list-cell {
  background-color: #fff;
  border-top: 1px solid #cccccc;
  border-right: 1px solid #cccccc;
}
.list-left > .list-cell {
  border-left: 1px solid #cccccc;
}
.width-all {
  width: 2808px;
}
.width-customer {
  width: 2518px;
}
.width-type {
  width: 2614px;
}
.list-cell__main {
  display: flex;
  /* width: 100%; */
  /* flex-direction: row;
  justify-content: center;
  align-items: center; */
  padding: 10px 0;
}
.height-36 {
  height: 36px !important;
}
.list-cell__index {
  width: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.list-cell__index span {
  border-radius: 50%;
  width: 20px;
  height: 20px;
  color: #fff;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  background-color: #c0c0c0;
}
.list-cell__content {
  width: 144px;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  text-align: center;
  color: #000;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.list-cell__150 {
  width: 150px;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  color: #000;
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.list-cell__100 {
  width: 100px;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  color: #000;
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.list-cell__toggle {
  width: 100px;
  height: 36px;
  text-align: center;
  line-height: 36px;
  font-size: 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.text-header {
  font-weight: bold;
  color: #000 !important;
}

.text-two-header {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  text-align: center;
}
.width-400 {
  width: 400px;
}
.width-200 {
  width: 200px;
}
.text-two-header > div {
  height: 18px;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  border-left: 1px dashed #8b8b8b;
}

.small-header {
  display: inline-block;
  width: 84px;
  height: 18px;
  text-align: center;
  font-size: 12px !important;
  font-weight: bold;
}
.gray {
  /* max-height: 300px;
  overflow-y: auto; */
  background: #f4f4f4;
}
@media screen and (min-width: 500px) {
  .filter-bar {
    padding: 6px 0 2px 0;
  }
  .list-cell__toggle {
    height: 20px;
    line-height: 20px;
  }
  .list-cell__content {
    height: 20px;
    line-height: 20px;
  }
  .list-cell__index span {
    width: 20px;
    height: 20px;
  }
  .list-cell__main {
    padding: 5px 0px;
  }
  .list-cell__150 {
    padding: 0px 0px;
    height: 20px;
    line-height: 20px;
  }
}
</style>